import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-obiettivicarousel',
  templateUrl: './obiettivicarousel.component.html',
  styleUrls: ['./obiettivicarousel.component.css']
})
export class ObiettivicarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
